import styled from 'styled-components';

export const YourAssetLabel = styled.text`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  text-anchor: middle;
`;

export const AssetValueLabel = styled.text`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #747d93;
  text-anchor: middle;
`;

export const AssetAreaLabel = styled.text`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #747d93;
  text-anchor: middle;
`;
